import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import styles from './planExpiry.module.scss';
import React, { useEffect, useState } from 'react';
import { StoreService } from '../../../services/api';
import Button from '../../FormControl/Button';
import { localStore } from '../../../services/browserStorage';
import Icon from '../../FormControl/Icon';
import { SDialogData } from 'pages/Login/types';
import { useAppContext } from 'contexts/AppContext';

const PlanExpiry = () => {
  const [planStatus, setPlanStatus] = useState('');
  const [planData, setPlanData] = useState<SDialogData>();
  const [isPlanExpiryModalOpen, setIsPlanExpiryModalOpen] = useState<boolean>(false);
  const { pageLoading } = useAppContext();

  const getPlanStatus = async () => {
    try {
      const response = await StoreService.getPlanStatus();
      const { data } = response.data;

      // Ensure proper structure for safety
      if (!data || !data.msg || !data.planStatus) {
        console.error('Invalid response data:', response.data);
        return;
      }

      // Compare dates (use ISO string for precision)
      const curDate = new Date().toISOString();
      const lastNotifyDate = localStore.get('lastPlanNotifyDate');

      if (
        planStatus &&
        planStatus !== 'active' &&
        data.msg &&
        (!lastNotifyDate || curDate.split('T')[0] !== lastNotifyDate.split('T')[0])
      ) {
        localStore.set('lastPlanNotifyDate', curDate);
        setIsPlanExpiryModalOpen(true);
      }

      // Set plan data
      setPlanData(data.data);
      localStore.set('planStatusMsg', data.msg);

      // Handle 'expiring' status
      if (data.planStatus === 'expiring') {
        localStore.set('planEndDate', data.planEndDate);
      }
    } catch (error) {
      console.error('Error fetching plan status:', error);
    }
  };

  const handlePlanUpdate = async (query: string) => {
    setIsPlanExpiryModalOpen(false);
    pageLoading.show();
    const response = await StoreService.updatePlanStatus(query);
    pageLoading.hide();
    localStore.remove('currentPlanStatus');
    localStore.remove('planEndDate');
    const redirectUrl = response.data.data.link;
    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
    } else {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (planStatus && planStatus !== 'active') {
      console.log('calling getPlanStatus ,: plan=>', planStatus);
      getPlanStatus();
    }
  }, [planStatus]);

  useEffect(() => {
    setPlanStatus(localStore.get('currentPlanStatus'));
  }, [localStore.get('currentPlanStatus')]);

  return isPlanExpiryModalOpen ? (
    <Dialog open={true} className={styles.dialog}>
      <DialogTitle>
        <Stack direction='row' alignItems='center' spacing={1}>
          <Icon icon={'ri-information-line'} size={'1.2rem'} />
          {planData?.title}
        </Stack>
      </DialogTitle>
      <DialogContent>
        <p className={planStatus === 'expired' ? styles.expired : styles.expiring}>
          {planData?.msg}
        </p>
      </DialogContent>
      <DialogActions>
        {planData?.actions.map((action, index) => (
          <Button
            key={index + 1}
            text={action.btnText}
            variant={action.variant || 'contained'}
            size={action.size || 'small'}
            onClick={() => handlePlanUpdate(action.btnText as string)}
          />
        ))}
      </DialogActions>
    </Dialog>
  ) : null;
};

export default PlanExpiry;
